import { createContext } from "react";

const PageContext = createContext({ page: 1, name: "" });

export default PageContext;
